/* refonte-page-contact.js - scope #rf-contact (meme comportement que refonte-page.js) */
(function(){
  var RF = document.getElementById('rf-contact');
  if(!RF) return;

  document.documentElement.classList.add('js');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(){
    RF.querySelectorAll('[data-rv]').forEach(function(n){ n.classList.add('on'); });
  }

  /* 1. Reveal au scroll */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
  RF.querySelectorAll('[data-rv]').forEach(function(n){ io.observe(n); });

  /* Filet de securite : onglet cache ou IO inactif, on n'ampute jamais le contenu */
  if(rm || document.visibilityState === 'hidden') showAll();
  addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') showAll(); });
  setTimeout(function(){
    var last = RF.querySelectorAll('[data-rv]');
    if(last.length && !last[0].classList.contains('on')) showAll();
  }, 3000);

  /* 2. Spotlight curseur de l'en-tete (desktop, hors reduced-motion) */
  var phd = RF.querySelector('#phd');
  if(phd && !rm && matchMedia('(hover: hover)').matches){
    phd.classList.add('spot');
    var raf=0, x=50, y=28;
    phd.addEventListener('mousemove', function(e){
      var r=phd.getBoundingClientRect();
      x=((e.clientX-r.left)/r.width)*100; y=((e.clientY-r.top)/r.height)*100;
      if(!raf) raf=requestAnimationFrame(function(){ phd.style.setProperty('--mx',x+'%'); phd.style.setProperty('--my',y+'%'); raf=0; });
    }, {passive:true});
  }

  /* 3. Confort de lecture du corps optionnel : tableaux scrollables, images allegees */
  var zone = RF.querySelector('#rf-content');
  if(zone){
    [].slice.call(zone.querySelectorAll('table')).forEach(function(t){
      if(t.parentNode && t.parentNode.classList.contains('cmp')) return;
      var w = document.createElement('div');
      w.className = 'cmp';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
    [].slice.call(zone.querySelectorAll('img')).forEach(function(i){
      i.setAttribute('loading', 'lazy'); i.setAttribute('decoding', 'async');
    });
  }

  /* 4. Succes / erreur : on amene l'utilisateur au bon endroit */
  var msg = RF.querySelector('.rf-ok') || RF.querySelector('.rf-err');
  if(msg){
    try { msg.scrollIntoView({block:'center', behavior: rm ? 'auto' : 'smooth'}); } catch(e){ msg.scrollIntoView(); }
  }
})();

/* menu mobile */
(function(){
  var hd = document.querySelector('[id^="rf-"] .hd') || document.querySelector('.hd');
  if(!hd) return;
  var b = hd.querySelector('.brg');
  if(!b) return;
  b.addEventListener('click', function(){
    var open = hd.classList.toggle('is-open');
    b.setAttribute('aria-expanded', String(open));
    b.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  });
  hd.querySelectorAll('.nav a').forEach(function(a){
    a.addEventListener('click', function(){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    });
  });
  document.addEventListener('click', function(e){
    if(hd.classList.contains('is-open') && !hd.contains(e.target)){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    }
  });
})();
